import React from 'react'
import Landing from './pages/Landing'
import Book from './pages/Book'
import './scss/custom.scss'
// media query
import { useMediaQuery } from 'react-responsive'
// react router
import { 
  BrowserRouter as Router, 
  Route, 
  Switch 
} from 'react-router-dom'

function App() {

  return (
    <div>
      <Router>
        <Switch>
          <Route exact path='/' component={Landing} />
          <Route exact path='/app/book/:book_id/:insight_name' component={Book} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
